// package.json is the only place the version is set
import { version } from "../../package.json";

console.log(`PlayCocola Client v${version}`);

// In the footer too, so a tester's screenshot or support email says which build they ran
const versionElement = document.querySelector("#app-version");
if (versionElement) versionElement.textContent = `v${version}`;
